import { useEffect } from "react";
import { useLocale } from "@/i18n/LocaleContext";
import { LOCALES, pathFor, DEFAULT_LOCALE } from "@/i18n/locales";
import { COMPANY } from "@/data/content";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

// Pro Route: <title>, description, canonical, hreflang-Alternativen, <html lang/dir>
export function usePageTitle(routeKey) {
  const { code, dir, t, routeKey: current } = useLocale();
  const key = routeKey ?? current ?? "home";
  useEffect(() => {
    const pageTitle = t.meta.pages[key] ?? "";
    document.title = pageTitle ? `${pageTitle} | ${t.meta.titleSuffix}` : t.meta.siteName;
    document.documentElement.lang = code;
    document.documentElement.dir = dir;

    upsert('meta[name="description"]', () => Object.assign(document.createElement("meta"), { name: "description" }))
      .setAttribute("content", t.meta.description);
    upsert('meta[property="og:description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:description");
      return m;
    }).setAttribute("content", t.meta.description);
    upsert('meta[property="og:locale"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:locale");
      return m;
    }).setAttribute("content", LOCALES.find((l) => l.code === code)?.tag.replace("-", "_") ?? "de_DE");

    upsert('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }))
      .setAttribute("href", `${COMPANY.siteUrl}${pathFor(code, key)}`.replace(/\/$/, key === "home" ? "/" : ""));

    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((l) => l.remove());
    const alternates = [
      ...LOCALES.map((l) => [l.code, `${COMPANY.siteUrl}${pathFor(l.code, key)}`]),
      ["x-default", `${COMPANY.siteUrl}${pathFor(DEFAULT_LOCALE, key)}`],
    ];
    alternates.forEach(([hreflang, href]) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = hreflang;
      link.href = href;
      document.head.appendChild(link);
    });
  }, [code, dir, t, key]);
}
